import app from './app';
import api from './api';
import Modal from './modal';
import updateAppModalContent from '../html/update-app-modal-content.hbs';

const INTERVAL = 30000;

export default class UpdateAppService {
    constructor(version, endpoint) {
        this.version = version;
        this.endpoint = endpoint;
        this.lastUpdateRequest = null;
    }

    init() {
        if (!app.isEditMode && this.version && this.endpoint) {
            setTimeout(this._checkVersion, INTERVAL);
        }
    }

    _checkVersion = () => {
        try {
            api.get(this.endpoint).then((response) => {
                if (response.data) {
                    const { version, title, message, updateTimeout } = response.data;
                    if (version && version > this.version) {
                        this._onVersionUpdate(version, title, message, updateTimeout);
                    }
                }
            }, (error) => {
                console.error(error);
            }).then(() => {
                setTimeout(this._checkVersion, INTERVAL);
            });
        } catch (e) {
            console.error(e);
        }
    };

    _onVersionUpdate(version, title, message, updateTimeout = 0) {
        this.version = version;

        if (this.lastUpdateRequest !== null) {
            clearTimeout(this.lastUpdateRequest);
        }

        this.lastUpdateRequest = setTimeout(() => {
            const modal = new Modal(updateAppModalContent({
                title,
                message
            }), { destroyOnClose: true });
            modal.open();
            this.lastUpdateRequest = null;
        }, updateTimeout * 1000);
    }
}
